var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconUpland = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.787 5.086a3.653 3.653 0 0 0-2.76.493 3.6 3.6 0 0 0-1.2 1.333 1.84 1.84 0 0 0-1.64.694l-2.427 3.066a8.96 8.96 0 0 0-7 4.827L3 20.579l4.667-.893H10.8a7.48 7.48 0 0 0 1.533-.174l.574-.146c3.693-1.12 6.493-5.054 5.333-9.014l2.093-1.106-1.8-.667a1.627 1.627 0 0 0-.506-1.133c.175-.304.422-.56.72-.747a2.333 2.333 0 0 1 3.187.68L23 6.646a3.627 3.627 0 0 0-2.213-1.56z",
    fill: "#1A202C",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconUpland, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-upland.8453e917.svg";
export { ForwardRef as ReactComponent };